<template>
    <v-container fluid width="80%">
          <v-row class="pa-3 align-center justify-center"><h1 class="textTitle--text">{{ $t('views.inventory.screenTitle') }}</h1></v-row>

<v-card class="ma-5 primary pa-5">
  <h1 class="d-flex justify-center text-font-weight textTitle--text">{{ $t('views.inventory.lowinvProdTitle') }}</h1>
  <v-data-table
    :headers="headers"
    :items="productsdblow"
    sort-by="name"
    class="elevation-5 tertiary pa-3 ma-5"
    :search="search"
  >
    
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 info font-weight-black black--text"
        @click="editInv(item)"
      >{{ $t('edit') }}</v-btn>
      
    </template>
    <template v-slot:[`item.percentage`]="{ item }">
      <div dark class="error d-flex justify-center"><h3 class="textTable--text"> {{Math.trunc((item.currenttInv/item.requestInv)*100)}}%</h3></div>
      
    </template>
    <template v-slot:[`item.codigo`]="{ item }">
      <h3 class="textTable--text">{{ item.codigo }}</h3>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <h3 class="textTable--text">{{ item.name }}</h3>
    </template>
    <template v-slot:[`item.currenttInv`]="{ item }">
      <h3 class="textTable--text">{{ item.currenttInv }}</h3>
    </template>
    
  </v-data-table> 
</v-card>

        <v-card class="ma-5 primary pa-5">
           <h1 class="d-flex justify-center text-font-weight textTitle--text">{{ $t('views.inventory.invProdTitle') }}</h1>
  <v-row class="ma-5 pa-3 primary justify-center">
    <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        outlined
        hide-details
        class="tertiary font-weight-black"
      ></v-text-field>
      </v-row>
      <v-data-table
    :headers="headers"
    :items="productsdbhigh"
    sort-by="name"
    class="elevation-5 tertiary pa-3 ma-5"
    :search="search"
  >
    
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 info font-weight-black black--text"
        @click="editInv(item)"
      >{{ $t('edit') }}</v-btn>
      
    </template>
    <template v-slot:[`item.percentage`]="{ item }">
      <div  dark class="green d-flex justify-center"><h3 class="textTable--text"> {{Math.trunc((item.currenttInv/item.requestInv)*100)}}%</h3></div>
      
    </template>
    <template v-slot:[`item.codigo`]="{ item }">
      <h3 class="textTable--text">{{ item.codigo }}</h3>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <h3 class="textTable--text">{{ item.name }}</h3>
    </template>
    <template v-slot:[`item.currenttInv`]="{ item }">
      <h3 class="textTable--text">{{ item.currenttInv }}</h3>
    </template>
    
  </v-data-table>  
  <v-dialog v-model="editDialog" max-width="80%" :retain-focus="false">
    <v-row class="pa-5 secondary justify-center">
            <v-card class="primary" width="95%">
        <v-card-title class="align-center justify-center"><h1 class="textTitle--text">{{ $t('views.inventory.modifTitle') }}</h1></v-card-title>
              <v-divider class="ma-3"></v-divider>
              <v-row class="ma-5 pa-5 primary justify-center" >
              <v-card class="secondary" width="45%">
              <v-row class="ml-5 align-center justify-center"><h2 class="mx-2">{{ $t('addproduct.prodName') }}</h2><h2 class="textMenu--text">{{this.selectedprod.name}}</h2></v-row>
              <v-row class="ml-5 align-center justify-center"><h2 class="ma-2">{{ $t('addproduct.prodCode') }}</h2><h2 class="textMenu--text">{{this.selectedprod.codigo}}</h2></v-row>
              <v-row class="ml-5 align-center justify-center"><h2 class="ma-2">{{ $t('addproduct.invInit') }}</h2><h2 class="textMenu--text">{{this.selectedprod.initInv}}</h2></v-row>
              <v-row class="ml-5 align-center justify-center"><h2 class="ma-2">{{ $t('headers.currentInv') }}</h2><h2 class="textMenu--text">{{this.selectedprod.currenttInv}}</h2></v-row>
              </v-card>
              </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-row class="ma-5 align-center justify-center secondary">
              <h2 class="ma-2 textMenu--text">{{ $t('addproduct.invRequest') }}</h2>
            <div class="ma-2" width="30%"><v-text-field filled  min=0 background-color="quinty" class="font-weight-black text-h5 textMenu--text" type="number" v-model.number="selectedprod.requestInv"></v-text-field></div>
            </v-row>
            <v-row class="ma-5 align-center justify-center secondary"><h2 class="ma-2 textMenu--text">{{ $t('addproduct.invAlert') }}</h2>
            <div class="ma-2" width="30%"><v-text-field max=100 min=0 background-color="quinty" class="font-weight-black text-h5 textMenu--text" type="number" filled v-model.number="selectedprod.invAlert"></v-text-field></div>
            </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-row class="ml-5 align-center justify-center">
            <v-btn @click="confirmEdit" class="ma-3 pa-2 success font-weight-black black--text" >{{ $t('confirm') }}</v-btn>
            <v-btn @click="editDialog=false" class="ma-3 pa-2 error font-weight-black black--text" >{{ $t('close') }}</v-btn>
            </v-row>
     
     
      </v-card>
    </v-row>
    </v-dialog>
</v-card>
    </v-container>
</template>

<script>



export default {
    data () {
        return {
            productsdblow:[],
            productsdbhigh:[],
            search:"",
            editDialog:false,
            
      selectedprod:[],

            }
},
computed:{
    headers(){
      var headers= [
        { text: this.$t('headers.actions'), value: 'actions', sortable: false, class: 'quaterny primary--text font-weight-black text-subtitle-2' },
              {
                text: this.$t('headers.prodCode'),
                align: 'start',
                value: 'codigo',
                class: 'quaterny primary--text font-weight-black text-subtitle-2'
              },
              {
                text: this.$t('headers.prodName'),
                align: 'start',
                value: 'name',

                class: 'quaterny primary--text font-weight-black text-subtitle-2'
              },
              { text: this.$t('headers.currentInv'), value: 'currenttInv',class: 'quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$t('headers.percent'), value:'percentage',class: 'quaterny primary--text font-weight-black text-subtitle-2'}
      ]
      return headers
    },
    productsdb(){
      return this.$store.state.products
    },
     getSlotName(){
    return `item.percentage`
  }
},
mounted(){
    this.update()

},
methods:{
  
  update(){
    this.getlowprod()
  },
  getlowprod(){
    this.productsdblow=[];
    this.productsdbhigh=[];
    for(var i=0;i<this.productsdb.length;i++){
      if(((this.productsdb[i].currenttInv/this.productsdb[i].requestInv)*100)<=this.productsdb[i].invAlert){
        this.productsdblow.push(this.productsdb[i])
      }
      else{
        this.productsdbhigh.push(this.productsdb[i])
      }
    }
  },
    editInv(prod){
        this.selectedprod=prod;
        this.editDialog=true;
    },
    confirmEdit(){
        var id=this.selectedprod.id
        var alert = this.selectedprod.invAlert
        var request = this.selectedprod.requestInv

        var payload = {"id":id,"request":request,"alert":alert}
        this.$store.dispatch('modifInv',payload)

       
          this.editDialog=false;
    }
},
}
</script>